<template>
  <div class="nomination" redesign>
    <!-- Header -->
    <div class="local-hero">
      <h1 class="local-hero-header">Nomination Details</h1>
    </div>

    <div class="nomination-survey-container form-container">
      <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
      <div v-if="!loading" class="nomination-survey card-shape">
        <SurveyResponseComponent
          :surveyResponse="surveyResponse"
          buttonText="Submit"
          @survey-done="handleSurveyDone"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import SurveyResponseComponent from '@/components/SurveyResponse'

import NominationsApi from '@/services/nominations'
import SurveyResponseModel from '@/services/surveyresponses'

export default {
  name: 'Nomination',
  components: {
    LoadSpinner,
    SurveyResponseComponent,
  },
  data() {
    return {
      loading: true,
      nominationId: null,
      surveyResponse: null,
    }
  },
  async mounted() {
    // Fetch the nomination, so we can lookup our survey
    var nominationId = this.$route.params.id
    if (nominationId) {
      this.nominationId = nominationId
      var nomination = await NominationsApi.get(nominationId)
    }

    // If we can't find the nomination, re-direct to the nominations home page
    if (!nomination) {
      this.$router.push({ name: 'ThirdPartyHome' })
    }

    // Load the survey response
    this.getSurveyResponse(nomination['survey_id'])
    this.loading = false
  },
  methods: {
    getSurveyResponse(id) {
      const surveyResponsePromise = SurveyResponseModel.api
        .retrieve(id)
        .then(surveyResponse => {
          this.surveyResponse = surveyResponse
        })
        .catch(error => {
          try {
            error.response.status === 404 ? (this.errorCode = 404) : (this.errorCode = 500)
          } catch {
            this.errorCode = 500
          }
        })
      return surveyResponsePromise
    },
    async handleSurveyDone(status) {
      if (status && status.success && status.complete) {
        await NominationsApi.updateStatus(this.nominationId, 'NOMINATED')
        this.$router.push({ name: 'ThirdPartyHome', params: { nominationSubmitted: true } })
      } else {
        this.$router.push({ name: 'ThirdPartyHome', params: { nominationSaved: true } })
      }

      return
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars']),
  },
}
</script>

<style lang="scss">
@import '@/styles/mixins/responsive';

.nomination-survey-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nomination-survey {
  padding: 2rem;
  width: 80%;
}
</style>
